module.exports = function date2($filter) {
  const suffixes = ['th', 'st', 'nd', 'rd'];
  return function dateFilter(input, format) {
    const dtfilter = $filter('date')(input, format);
    const day = parseInt($filter('date')(input, 'dd'), 10);
    const relevantDigits = day < 30 ? day % 20 : day % 30;
    const suffix = relevantDigits <= 3 ? suffixes[relevantDigits] : suffixes[0];
    return typeof dtfilter === 'string' ? dtfilter.replace('oo', suffix) : dtfilter;
  };
};
